import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { generatePath, Link } from 'react-router-dom'
import { ROUTES } from '../../../../routes'
import styles from './index.module.scss'
import { useDispatch } from 'react-redux'
import { UPDATE_INVOICE_DATA } from '../../../../pages/invoices-page/reducer/action'

export default function OpenStatus ({ invoice, hauler, invoiceProvider = null }) {
  const dispatch = useDispatch()

  const openSendInvoiceModal = () => {
    dispatch({ type: UPDATE_INVOICE_DATA, payload: { isModalOpen: true, data: invoice } })
  }
  return (
    <ul className={cn('dropdown-menu', styles.invoiceActions)}>
      <li>
        <Link to={generatePath(ROUTES.invoicePayment, { id: invoice.id })}>
          <span>Collect Payment</span>
          <i className='material-icons'>paid</i>
        </Link>
        <Link to={generatePath(ROUTES.invoice, { id: invoice.id })}>
          <span>Void Invoice</span>
          <i className='material-icons'>close</i>
        </Link>
        {hauler.quickbooks.isConnected && <Link to={generatePath(ROUTES.invoicesExport, { id: invoice?.id })}>
          <span>Export to QBO</span>
          <i className='material-icons'>forward</i>
        </Link>}
        {
          invoiceProvider && invoiceProvider.toUpperCase() === 'DISPATCHER' &&
            <button className={styles.invoiceActionButton} onClick={openSendInvoiceModal}>
              {
                invoice?.lastSent === null
                  ? <span>Send Invoice</span>
                  : <span>Resend Invoice</span>
              }
              <i className='material-icons'>send</i>
            </button>
        }
      </li>
    </ul>
  )
}
OpenStatus.propTypes = {
  hauler: PropTypes.shape({
    id: PropTypes.string.isRequired,
    isWastepayApproved: PropTypes.bool.isRequired,
    quickbooks: PropTypes.shape({
      isConnected: PropTypes.bool.isRequired
    }).isRequired
  }),
  invoice: PropTypes.shape({
    id: PropTypes.string.isRequired,
    lastSent: PropTypes.string
  }).isRequired,
  invoiceProvider: PropTypes.string
}
